<template>
    <div class="layout">
        <Layout>
            <Header>
                <top-head></top-head>
            </Header>
            <Layout style="height:calc(100vh - 64px)">
                <Sider collapsible :collapsed-width="78" v-model="isCollapsed" style="width: 250px;min-width: 250px;max-width: 250px;flex: 0 0 250px;background-color: #323a4d">
                    <Menu ref="leftmenu" @on-select="selectItem" @on-open-change="isCollapsed=false" :active-name="activeName" theme="dark" width="auto" :accordion="true" :open-names="opennames" :class="menuitemClasses">
                        <!-- 动态菜单 -->
                        <div v-for="item in menuList">
                            <template v-if="item.type">
                                <left-menu-nav :menuList='item' :key='item.meta.order'></left-menu-nav>
                            </template>
                            <template v-else>
                                <div v-for="main in item.children">
                                    <menu-item :name="main.meta.order" :to="main.path" :key='main.meta.order'>
                                        <Icon :type="main.type" />
                                        <span>{{ main.meta.title }}</span>
                                    </menu-item>
                                </div>
                            </template>
                        </div>
                    </Menu>
                </Sider>
                <Layout :style="{padding: '0 10px 10px',background:'#fff'}">
                    <router-view></router-view>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>
<script>
    import leftMenuNav from './leftMenuNav'
    import TopHead from './TopHead'
    export default {
        components: {TopHead,leftMenuNav},
        data () {
            return {
                opennames:[],
                activeName:'',
                submenuname:[],
                isCollapsed: false
            }
        },
        created(){
            // 多级菜单 刷新收缩问题
            if(this.$route.meta && this.$route.meta.order){
                // 当前高亮
                this.activeName = this.$route.meta.order;
                this.submenuname=this.$route.meta.order.split('-');
                if(this.submenuname.length==5){
                    // 五级菜单
                    this.opennames=[this.$route.meta.order.split('-')[0],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1]+'-'+this.$route.meta.order.split('-')[2],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1]+'-'+this.$route.meta.order.split('-')[2]+'-'+this.$route.meta.order.split('-')[3]];
                }else if(this.submenuname.length==4){
                    // 四级菜单
                    this.opennames=[this.$route.meta.order.split('-')[0],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1]+'-'+this.$route.meta.order.split('-')[2]];
                }else if(this.submenuname.length==3){
                    // 三级菜单
                    this.opennames=[this.$route.meta.order.split('-')[0],this.$route.meta.order.split('-')[0]+'-'+this.$route.meta.order.split('-')[1]];
                }else if(this.submenuname.length==2&&this.submenuname[0]!=="0"){
                    // 二级菜单
                    this.opennames.push(this.$route.meta.order.split('-')[0]);
                }
            }
        },
        watch:{
            // 收缩
            isCollapsed(val){
                if(val){
                    this.opennames=[];
                    this.$nextTick(()=>{
                        this.$refs.leftmenu.updateOpened();
                    });
                }
            }
        },
        computed: {
            menuitemClasses: function () {
                return [
                    'menu-item',this.isCollapsed ? 'collapsed-menu' : ''
                ]
            },
            // 菜单栏
            menuList() {
                return global.antRouter;
            }
        },
        methods:{
            selectItem:function(name){
                this.isCollapsed=false;
                if(name.startsWith('0')){
                    this.opennames=[];
                    this.$nextTick(()=>{
                        this.$refs.leftmenu.updateOpened();
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .layout{
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }
    .layout-con{
        height: 100%;
        width: 100%;
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 144px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu>>>.ivu-icon-ios-arrow-down {
        display: none;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .ivu-layout-sider
    {
        overflow-y: auto;
    }
        /* 滚动条 */
    .ivu-layout-sider::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .ivu-layout-sider::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .ivu-layout-sider::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .ivu-layout-sider::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .ivu-layout-sider>>>.ivu-layout-sider-trigger
    {
        background-color: #323a4d;
        display: none;
    }
    .ivu-layout-sider>>>.ivu-menu-dark
    {
        background-color: #2f374a;
    }
    .ivu-layout-sider>>>.ivu-menu
    {
        background-color: #2f374a;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
        color:#fff;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover{
        background-color: #2d8cf0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Main.vue